import React, { useContext, useState, useEffect } from 'react';
import { Helmet } from '@dr.pogodin/react-helmet';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import AuthContext from '../../context/AuthContext';
import { authPost } from '../../Utilities/Api';
import './Home.css';

const Home = () => {
  const { login, user, loading } = useContext(AuthContext);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [darkMode, setDarkMode] = useState(localStorage.getItem('theme') === 'dark');
  const [submitting, setSubmitting] = useState(false);

  const navigate = useNavigate();

  // 🔍 DEBUG: Log Home Render
  useEffect(() => {
    console.log("🏠 [Home] Component Rendered. User:", user ? user.username : "null", "Loading:", loading);
  }, [user, loading]);

  // Theme
  useEffect(() => {
    document.documentElement.classList.toggle('dark', darkMode);
    localStorage.setItem('theme', darkMode ? 'dark' : 'light');
  }, [darkMode]);

  // Redirect ONLY here
  useEffect(() => {
    if (!loading && user?._id) {
      console.log("🔀 [Home] User is logged in. Redirecting to /feed");
      navigate('/feed', { replace: true });
    }
  }, [user, loading, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;

    console.log("📨 [Home] Submitting Login Form for:", email);
    setSubmitting(true);

    try {
      console.log("📡 [Home] POST /auth/login...");
      const res = await authPost('/auth/login', { email, password });
      const data = await res.json().catch(() => ({}));

      console.log("📥 [Home] Login Response:", res.status, data);

      if (res.ok && data?.accessToken && data?.user) {
        console.log("✅ [Home] Login Success! Updating AuthContext...");
        login({
          accessToken: data.accessToken,
          accessTokenExpires: data.accessTokenExpires,
          user: data.user,
        });

        toast.success('Welcome back!', { icon: '👋' });
      } else {
        console.warn("❌ [Home] Login Failed:", data?.message);
        toast.error(data?.message || 'Login failed', { icon: '💬 talkear' });
      }
    } catch (err) {
      console.error("❌ [Home] Login Error:", err);
      toast.error('Something went wrong. Try again.', { icon: '💬 talkear' });
    } finally {
      setSubmitting(false);
    }
  };

  // Home is PUBLIC — do not block it
  return (
    <div className="Home-container">
      <Helmet>
        <title>talkear</title>
      </Helmet>

      {/* Dark Mode */}
      <div className="dark-toggle">
        <label className="switch">
          <input
            type="checkbox"
            checked={darkMode}
            onChange={() => setDarkMode(!darkMode)}
          />
          <span className="slider round"></span>
        </label>
      </div>

      <div className="Home-content-wrapper">
        <div className="Home-branding">
          <h2 className="Home-title">talkear</h2>
          <h3 className="Home-subtitle">
            Where people come to talk – No Ads, No Trackers Ever
          </h3>
        </div>

        <div className="Home-form-wrapper">
          <div className="Home-form-box">
            <div className="Home-form-section">
              <h2 className="Home-form-title">Sign in</h2>

              <form onSubmit={handleSubmit} className="Home-form">
                <input
                  type="email"
                  placeholder="Email address"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />

                <input
                  type="password"
                  placeholder="Password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />

                <button disabled={submitting}>
                  {submitting ? 'Signing in...' : 'Sign in'}
                </button>
              </form>

              <p className="Home-agreement">
                By continuing, you agree to the Terms of use and Privacy Policy.
              </p>
            </div>

            <div className="Home-divider-section">
              <span>or</span>
            </div>

            <Link
              to="/register"
              className="Home-button-outline"
              onClick={() => console.log("🔗 [Home] Clicked 'Create new account' link")}
            >
              Create new account
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;